export default "__VITE_ASSET__Dvux9EAE__"